class CalculateurQuantite extends HTMLElement {
  constructor() {
    super();
    this.qty_paquet = this.dataset.qtyPaquet;
    this.unit = this.dataset.unit;
    this.qty_by_five = this.dataset.qtyByFive;
    this.querySelector('.calculateur-table-ligne-selecteur select#poids').addEventListener('change', this.onChangePoids.bind(this));
    this.init();
  }

  init() {
    var duree = Math.round(this.qty_paquet / this.qty_by_five);
    this.updateResult(this.qty_by_five, duree);
  }

  onChangePoids(event) {
    var qty_by_day = this.qty_by_five * (event.target.value / 5);
    var duree = Math.round(this.qty_paquet / qty_by_day);
    this.updateResult(qty_by_day, duree);
  }

  updateResult(qty, duree) {
    var plurielUnite = '';
    if (qty >= 2) plurielUnite = 's';
    this.querySelector('.calculateur-table-ligne-value-qty').innerHTML = qty.toString().replace('.', ',') + ' ' + this.unit + plurielUnite;
    if (duree < 31) {
      var plurielJours = '';
      if (duree > 1) plurielJours = 's';
      this.querySelector('.calculateur-table-ligne-value-duree').innerHTML = duree.toString().replace('.', ',') + ' jour' + plurielJours;
    } else {
      this.querySelector('.calculateur-table-ligne-value-duree').innerHTML = (Math.round((duree * 10) / 31, 2) / 10).toString().replace('.', ',') + ' mois';
    }
  }
}

customElements.define('calculateur-quantite', CalculateurQuantite);
